import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { Response } from '@shared/models/Response';
import { AppConfigService } from '@core/services/app-config/app-config.service';
import { AppSettingsService } from '@core/services/app-settings/app-settings.service';
import { AppSettings } from '@models/Settings.model';

@Injectable({
    providedIn: 'root'
})
export class SettingAPIService {
    /**
     * Lazy-loaded base URL getter with /admin suffix
     * Uses getter to avoid circular dependency with AppConfigService
     */
    private get baseUrl(): string {
        return this.configService.getApiUrl();
    }

    constructor(
        private httpService: HttpClient,
        private configService: AppConfigService,
        private appSettingsService: AppSettingsService
    ) {}

    /**
     * Clears the backend settings cache. The endpoint returns the freshly
     * rebuilt settings (same shape as /settings/public), which we apply so the
     * UI reflects the new values without a manual page refresh.
     */
    clearCache(): Observable<HttpResponse<Response<AppSettings>>> {
        return this.httpService
            .delete<Response<AppSettings>>(`${this.baseUrl}/settings/clear-cache`, {
                observe: 'response'
            })
            .pipe(
                tap((res) => {
                    if (res.status === 200 && res.body?.result) {
                        this.appSettingsService.apply(res.body.result);
                    }
                })
            );
    }

    fetchSettings(): Observable<HttpResponse<Response<AppSettings>>> {
        return this.httpService
            .get<Response<AppSettings>>(`${this.baseUrl}/settings/public`, {
                observe: 'response'
            })
            .pipe(
                tap((res) => {
                    if (res.status === 200 && res.body?.result) {
                        const settingsArray = res.body.result;

                        if (settingsArray) {
                            this.appSettingsService.apply(settingsArray);
                            console.log('Primary setting cached');
                        }

                        console.log('Settings automatically cached in session');
                    }
                })
            );
    }
}
